'use strict';
angular.module('sharedQuickPreviewModule', ['shareDetailModule']).controller('sharedQuickPreviewCtrl', [
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    'initComDataService',
    'trsHttpService',
    'localStorageService',
    'storageListenerService',
    '$q',
    'trsspliceString',
    'resourceCenterService',
    '$filter',
    '$compile',
    'resCtrModalService',
    'resSharedService',
    function(
        $scope,
        $state,
        $stateParams,
        $timeout,
        initComDataService,
        trsHttpService,
        localStorageService,
        storageListenerService,
        $q,
        trsspliceString,
        resourceCenterService,
        $filter,
        $compile,
        resCtrModalService,
        resSharedService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                isOpenedPanel: { 0: true }, // 第一块版面默认打开
                currModule: 'gxgk',
                isShowPanel: true, // 默认显示分组列表（仅全部文字）
                hasphoto: false, // 是否显示图集
                searchShow: false, // 是否显示检索
                screenShow: false, // 是否显示更多筛选
                isMedia: false, // 是否为本媒体稿件
                methodname: {
                    // 打印操作的查看详情方法名
                    1: 'getNewsShareDoc',
                    2: 'getPicsShareDoc',
                    3: 'getLinkShareDoc',
                    5: 'getActivityShareDoc',
                    6: 'getTopicShareDoc',
                    7: 'getVideoShareDoc',
                    8: 'getLiveShareDoc',
                },
                singleGraph: false, // 是否为单图模式
                isESSearch: false, // 是否进行ES检索
                showRightDetail: false, // 是否显示右侧详情
                curSelected: '', // 当前选中的详情ID
                isUGC: $stateParams.isugc == '1', // 是否是ugc稿件
                UGCSearch: false, // 是否进行ugc检索
                isShowPanelItem: true,
                isDataOfFirst: !!angular.isUndefined($stateParams.parentid),
                isCountyFeed: $state.params.manutype === 'countyFeedList',
                listMode: resSharedService.getListMode(),
            };
            $scope.data = {
                casDataArea: [], // 地区的级联数组
                items: [], // 图集数据
                operFlags: [], // 取签见撤重
                selectedArrat: [], // 缓存中选中的对象
                keywords: '', // 检索的关键词
                areaId: '', // 当前选中的地域id
                sharedTenant: {
                    data: [],
                    curValue: {},
                }, // 供稿单位对象
            };
            $scope.basicParams = {
                // 基础参数
                channelName: $scope.status.currModule,
                typeName: $stateParams.typename && $stateParams.typename.replace('zyzx', ''),
                nodeId: $stateParams.nodeid,
                nodename: decodeURINodeName($stateParams.nodename),
            };
            $scope.page = {
                // 分页信息
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.params = {
                // 请求参数
                serviceid: 'mlf_releaseSource',
                methodname: !$scope.status.isDataOfFirst ? 'queryShareDocsDataCount' : 'queryShareDocsDataCountOfFirst',
                CurrPage: $scope.page.CURRPAGE,
                PageSize: 20,
                MetaCategoryId: $stateParams.nodeid,
                DocType: '', // 稿件类型
                ShareTimeStart: '', // 开始日期
                ShareTimeEnd: '', // 结束
                OriginalType: '', // 原创稿类型
                IsUnit: false, // 本媒体稿件
                fromTenantId: '',
            };
            $scope.ugcParams = {
                serviceid: 'mlf_ugc',
                methodname: 'queryArticleCount',
                Method: 'queryArticleCount',
                MetaCategoryId: $scope.status.isDataOfFirst ? '' : $stateParams.nodeid,
                start: '',
                end: '',
                FirstClassId: $scope.status.isDataOfFirst ? $stateParams.nodeid : '',
            };
        }

        /**
         * [decodeURINodeName description] 强行兼容解码问题造成的nodename为编码后的形态的情况
         * @param  {[type]} nodename [description] 节点名
         * @return {[type]}          [description]
         */
        function decodeURINodeName(nodename) {
            if (!nodename) {
                return nodename;
            }
            var name = nodename;
            while (name.indexOf('%') > -1) {
                name = decodeURIComponent(name);
            }
            return name;
        }

        /**
         * [initData description] 快速预览初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            listenStorage();
            $scope.data.item = [];
            $scope.data.panels = [];
            initDropDown().then(function() {
                if (angular.isDefined($scope.$root.filterData)) {
                    // 判断是否有传递的数据
                    var filterData = angular.copy($scope.$root.filterData);
                    $scope.page = filterData.page;
                    $scope.params.CurrPage = $scope.page.CURRPAGE;
                    $scope.params.PageSize = $scope.page.PAGESIZE;
                    $scope.params.fromTenantId = filterData.sharedTenant.curValue.FromTenantId;

                    $scope.data.fromdate = filterData.fromdate;
                    $scope.data.untildate = filterData.untildate;
                    // $scope.params = filterData.params;
                    $scope.docType = filterData.docType; // 稿件类型
                    $scope.data.sharedTenant = filterData.sharedTenant; // 供稿单位
                    $scope.originType = filterData.originType; // 原创稿类型
                    $scope.status.isMedia = filterData.isMedia; // 是否本媒体稿件
                    $scope.keyType = filterData.keyType; // 当前检索信息
                    $scope.data.keywords = filterData.keywords; // 当前检索词
                    $scope.status.UGCSearch = filterData.UGCSearch; // 当前检索词
                    // 默认展开更多筛选项
                    if ($scope.status.isMedia || filterData.area || $scope.docType.curValue.value != '' || $scope.originType.curValue.value != '') {
                        $scope.status.screenShow = true;
                    }
                    // 默认展开检索信息
                    if (!!$scope.data.keywords || $scope.keyType.curValue.value != '') {
                        $scope.status.searchShow = true;
                    }
                    // 默认选中的地域信息
                    if (filterData.area && filterData.length > 0) {
                        $scope.data.casDataArea.push($scope.$root.filterData.area[0]);
                    }
                    if (filterData.panelsData) {
                        // 分组数据
                        $scope.data.panels = angular.copy(filterData.panelsData);
                        if ($scope.status.isUGC) {
                            angular.forEach($scope.data.panels, function(value, key) {
                                value.DOCUMENTS = value.DOCUMENTS instanceof Array ? value.DOCUMENTS : [];
                                value.DOCUMENTS = value.DOCUMENTS.map(function(v, k) {
                                    var obj = {
                                        METADATAID: v.id,
                                        DOCTYPEID: '1',
                                        TITLE: v.articleTitle,
                                        SHARETIME: v.postTime,
                                    };
                                    return obj;
                                });
                            });
                        }
                        $scope.status.isOpenedPanel = angular.copy(filterData.isOpenedPanel); // 默认展开项
                        dealWithEachGroup($scope.data.panels);
                    }
                    if (filterData.listData) {
                        // 是否图集稿，是则直接传递图集列表数据
                        if (angular.isDefined(filterData.singleGraph)) {
                            // 是否是图集稿
                            $scope.status.hasphoto = true;
                            $scope.status.singleGraph = filterData.singleGraph; // 是否单图
                        } else if (angular.isDefined(filterData.isESSearch) || angular.isDefined(filterData.UGCSearch)) {
                            // ESS检索，普通列表
                            $scope.status.isShowPanel = false;
                            $scope.status.hasphoto = false;
                            $scope.status.searchShow = true;
                            $scope.status.isESSearch = filterData.isESSearch;
                            $scope.status.UGCSearch = filterData.UGCSearch;
                        }
                        $scope.data.items = filterData.listData;
                        storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                        if ($scope.data.items.length > 0) {
                            showDetail($scope.data.items[0]);
                            initOperFlag($scope.data.items);
                        }
                    }
                    $scope.$root.filterDataBack = angular.copy($scope.$root.filterData);
                    // getFilterDataBack();
                }
                requestData();
            });
            $scope.$on('$destroy', function() {
                // 销毁对象
                delete $scope.$root.filterData;
                delete $scope.$root.filterDataBack;
            });
        }

        /**
         * [getFilterDataBack description]获取跳转回普通视图存储信息
         * @return {[type]} [description]
         */
        function getFilterDataBack() {
            $scope.$root.filterDataBack = {
                page: $scope.page, // 分页
                fromdate: $scope.data.fromdate, // 开始时间
                untildate: $scope.data.untildate, // 结束时间
                params: $scope.params, // 其他条件
                area: $scope.data.area, // 地域信息
                docType: $scope.docType, // 当前稿件类型
                originType: $scope.originType, // 原创稿类型
                keyType: $scope.keyType, // 当前检索信息
                isMedia: $scope.status.isMedia, // 是否本媒体稿件
                keywords: $scope.data.keywords, // 当前检索词
            };
            if ($scope.status.hasphoto) {
                // 是否图集稿，是则直接传递图集列表数据
                $scope.$root.filterDataBack.listData = $scope.data.items;
                $scope.$root.filterDataBack.singleGraph = $scope.status.singleGraph; // 是否单图
            } else if ($scope.status.isESSearch) {
                // ESS检索
                $scope.$root.filterDataBack.listData = $scope.data.items;
                $scope.$root.filterDataBack.isESSearch = $scope.status.isESSearch;
            } else if ($scope.status.UGCSearch) {
                $scope.$root.filterDataBack.listData = $scope.data.items;
                $scope.$root.filterDataBack.UGCSearch = $scope.status.UGCSearch;
            } else {
                // 分组列表
                $scope.$root.filterDataBack.panelsData = $scope.data.panels;
                $scope.$root.filterDataBack.isOpenedPanel = angular.copy($scope.status.isOpenedPanel);
            }
        }

        /**
         * [dealWithEachGroup description]处理快速预览时分组展示groupData传递数据的取签见撤重
         * @param  {[type]} panels [description]
         * @return {[type]}        [description]
         */
        function dealWithEachGroup(panels) {
            for (var j = 0; j < panels.length; j++) {
                if (angular.isDefined(panels[j].DOCUMENTS) && panels[j].DOCUMENTS.length > 0) {
                    initOperFlag($scope.data.panels[j].DOCUMENTS); // 初始化取签见撤重
                    if ($scope.data.panels[j].DOCUMENTS.length > 0) {
                        // 默认显示第一篇详情
                        // showDetail($scope.data.panels[j].DOCUMENTS[0]);
                    }
                }
            }
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
         * [initDropDown description] 初始化下拉列表数据
         * @return {[type]} [description]
         */
        function initDropDown() {
            var defer = $q.defer();
            $scope.docType = {
                data: initComDataService.newsType(),
                curValue: initComDataService.newsType()[0],
            };
            $scope.keyType = {
                data: initComDataService.searchKeyType(),
                curValue: initComDataService.searchKeyType()[0],
            };
            $scope.originType = {
                data: initComDataService.originType(),
                curValue: initComDataService.originType()[0],
            };
            initTenant().then(function() {
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initTenant description] 初始化供稿单位
         *
         * @return  {[type]}  [return description]
         */
        function initTenant() {
            var defer = $q.defer();
            // 判断如果不是县融供稿不执行此请求
            if ($state.params.manutype !== 'countyFeedList') {
                defer.resolve();
            } else {
                var params = {
                    serviceid: 'mlf_releaseSource',
                    methodName: 'queryHaveSharedTenantName',
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.sharedTenant.data = [
                        {
                            FromTenantId: '',
                            FromTenantName: '全部供稿单位',
                        },
                    ].concat(data);
                    $scope.data.sharedTenant.curValue = data[0];
                    defer.resolve();
                });
            }
            return defer.promise;
        }

        /**
         * [requestData description] 请求列表数据
         * @return {[type]} [description]
         */
        function requestData(isPageChanged) {
            if (isPageChanged) {
                $scope.page.CURRPAGE = 1;
            }
            var defer = $q.defer();
            $scope.data.item = [];
            $scope.data.panels = [];
            if ($scope.status.isESSearch === true || $scope.status.UGCSearch) {
                $scope.status.isShowPanel = false;
                $scope.status.hasphoto = false;
                if ($scope.status.UGCSearch) {
                    UGCSearch();
                } else {
                    requestESSearch();
                }
            } else if ($scope.params.DocType == '2') {
                $scope.status.isShowPanel = false;
                $scope.status.hasphoto = true;
                requestImgFlow();
            } else {
                if ($scope.status.listMode === 'banmian') {
                    let params;
                    if ($scope.status.isUGC === true) {
                        $scope.ugcParams.start = $scope.data.fromdate || '';
                        $scope.ugcParams.end = $scope.data.untildate || '';
                        params = angular.copy($scope.ugcParams);
                    } else {
                        params = angular.copy($scope.params);
                    }
                    $scope.status.isShowPanel = true;
                    $scope.status.hasphoto = false;
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        if ($scope.status.isUGC) {
                            $scope.data.panels = data.data;
                        } else {
                            $scope.data.panels = data;
                        }
                        angular.forEach($scope.data.panels, function(value, key) {
                            value.currPage = 1;
                        });
                        if ($scope.data.panels.length > 0) {
                            queryItemsByPanel(0);
                        }
                    });
                } else {
                    queryItemsByPanel(0);
                }
            }
            defer.resolve();
            return defer.promise;
        }

        /**
         * [UGCSearch description]UGC检索
         *
         * @return  {[type]}  [return description]
         */
        function UGCSearch() {
            $scope.status.isShowPanel = false;
            $scope.status.hasphoto = false;
            $scope.data.selectedArrat = [];
            var params = {
                serviceid: 'mlf_ugc',
                methodname: 'queryArticles',
                Method: 'queryArticles',
                MetaCategoryId: !$scope.status.isDataOfFirst ? $stateParams.nodeid : '',
                SearchWord: $scope.data.keywords,
                ContainPage: '1',
                CurrPage: $scope.page.CURRPAGE - 1,
                PageSize: $scope.page.PAGESIZE,
                start: $scope.data.fromdate,
                end: $scope.data.untildate,
                FirstClassId: $scope.status.isDataOfFirst ? $stateParams.nodeid : '',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.status.UGCSearch = true;
                $scope.ITEMCOUNT = !data || !data.data || !data.data.totalResults ? [] : data.data.totalResults;
                data = !data || !data.data || !data.data.ldata ? [] : data.data.ldata;
                angular.forEach(data, function(value, key) {
                    value.METADATAID = value.id;
                    value.DOCTYPEID = '1';
                    value.TITLE = value.articleTitle;
                    value.SHARETIME = value.postTime;
                });
                $scope.data.items = data;
                if ($scope.data.items.length > 0) {
                    // 显示第一个详情
                    showDetail($scope.data.items[0]);
                }
                initOperFlag(data);
            });
        }

        /**
         * [requestESSearch description] 请求ES列表数据
         * @return {[type]} [description]
         */
        function requestESSearch() {
            var params;
            if ($scope.data.areaId !== '') {
                params = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForShareTopicAndArea',
                    searchParams: getESSearchParamsByArea(),
                };
            } else {
                params = {
                    serviceid: 'mlf_hybasesearch',
                    methodname: 'queryForTongYiGongGaoDoc',
                    searchParams: getESSearchParams(),
                };
            }
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                .then(function(data) {
                    $scope.data.items = data.DATA;
                    $scope.page = data.PAGER;
                    if ($scope.data.items.length > 0) {
                        // 显示第一个详情
                        showDetail($scope.data.items[0]);
                    }
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                    $scope.data.operFlags = [];
                    return initOperFlag(data.DATA);
                })
                .then(function() {
                    getDraftRecord($scope.data.items);
                    // getGroupIssuedCounts($scope.data.items);
                    getFilterDataBack();
                });
        }

        /**
         * [getESSearchParams description]设置ES检索参数
         * @return {[json]} [description]
         */
        function getESSearchParams() {
            var searchParams = {
                PAGESIZE: $scope.page.PAGESIZE + '',
                PAGEINDEX: $scope.page.CURRPAGE + '',
                searchFields: [
                    {
                        searchField: 'docType',
                        keywords: $scope.docType.curValue.value,
                    },
                    {
                        searchField: 'newsType',
                        keywords: $scope.basicParams.nodeId,
                    },
                    {
                        searchField: 'timeType',
                        keywords: $scope.data.fromdate ? $scope.data.fromdate + ';' + $scope.data.untildate : '0',
                    },
                    {
                        searchField: 'isOnlyMedia',
                        keywords: $scope.status.isMedia,
                    },
                    {
                        searchField: '_sort',
                        keywords: 'time',
                    },
                    {
                        searchField: $scope.keyType.curValue.value,
                        keywords: $scope.data.keywords,
                    },
                ],
            };
            if ($scope.status.isCountyFeed) {
                searchParams.searchFields.push({
                    searchField: 'fromTenantId',
                    keywords: $scope.params.fromTenantId || '',
                });
            }
            return JSON.stringify(searchParams);
        }

        /**
         * [getESSearchParamsByArea description]设置ES检索参数（地域）
         * @return {[json]} [description]
         */
        function getESSearchParamsByArea() {
            var searchParams = {
                PAGESIZE: $scope.page.PAGESIZE + '',
                PAGEINDEX: $scope.page.CURRPAGE + '',
                searchFields: [
                    {
                        searchField: 'contentType',
                        keywords: 'area',
                    },
                    {
                        searchField: 'typeValue',
                        keywords: $scope.data.areaId.split('_')[1],
                    },
                    {
                        searchField: 'newsType',
                        keywords: '',
                    },
                    {
                        searchField: 'timeType',
                        keywords: $scope.data.fromdate ? $scope.data.fromdate + ';' + $scope.data.untildate : '0',
                    },
                    {
                        searchField: 'docType',
                        keywords: $scope.docType.curValue.value,
                    },
                    {
                        searchField: $scope.keyType.curValue.value,
                        keywords: $scope.data.keywords,
                    },
                    {
                        searchField: 'isOnlyMedia',
                        keywords: $scope.status.isMedia,
                    },
                    {
                        searchField: '_sort',
                        keywords: 'time',
                    },
                ],
            };
            if ($scope.status.isCountyFeed) {
                searchParams.searchFields.push({
                    searchField: 'fromTenantId',
                    keywords: $scope.params.fromTenantId || '',
                });
            }
            return JSON.stringify(searchParams);
        }

        /**
         * [requestImgFlow description] 请求图片流列表
         * @return {[type]} [description]
         */
        function requestImgFlow() {
            var params = angular.copy($scope.params);
            params.methodname = $scope.status.isDataOfFirst ? 'queryShareDocsForCloudOfFirst' : 'queryShareDocsForCloud';
            params.PageSize = $scope.page.PAGESIZE;
            params.CurrPage = $scope.page.CURRPAGE;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                angular.forEach(data.DATA, function(value, key) {
                    if (angular.isArray(value.DOC_PICTURELIST) && value.DOC_PICTURELIST.length > 0) {
                        value.WIDTH = value.DOC_PICTURELIST[0].WIDTH;
                        value.HEIGHT = value.DOC_PICTURELIST[0].HEIGHT;
                    }
                });
                $scope.data.items = $scope.data.items.concat(data.DATA);
                $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
            });
        }

        /**
         * [searchWithKeyword description] 根据条件筛选稿件
         * @param  {[type]} key   [description] 筛选类型
         * @param  {[type]} value [description] 筛选内容
         * @return {[type]}       [description]
         */
        $scope.searchWithKeyword = function(key, value) {
            if (key == 'ShareTime') {
                $scope.params.ShareTimeStart = $scope.data.fromdate;
                $scope.params.ShareTimeEnd = $scope.data.untildate;
            } else {
                $scope.params[key] = value;
            }
            if (key == 'DocType' && value != '2') {
                $scope.status.hasphoto = false;
            } else if (key == 'DocType' && value == '2') {
                $scope.status.hasphoto = true;
            }
            $scope.params.CurrPage = $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            requestData();
        };

        /**
         * [toggleOpenPanel description] 下拉或收起面板
         * @param  {[type]} index [description] 当前面板的index
         * @return {[type]}       [description]
         */
        $scope.toggleOpenPanel = function(index) {
            $scope.status.isOpenedPanel[index] = !$scope.status.isOpenedPanel[index];
            getFilterDataBack();
            if ($scope.data.panels[index].DOCUMENTS && $scope.data.panels[index].DOCUMENTS.length) {return;}
            queryItemsByPanel(index);
        };

        /**
         * [queryUGCItemsByPanel description] 请求UGC数据
         * @param  {[type]} index [description]
         * @return {[type]} [description]
         */
        function queryUGCItemsByPanel(index) {
            var params = {
                serviceid: 'mlf_ugc',
                methodname: 'queryArticles',
                Method: 'queryArticles',
                MetaCategoryId: !$scope.status.isDataOfFirst ? $stateParams.nodeid : '',
                ContainPage: '0',
                start: $scope.data.fromdate,
                end: $scope.data.untildate,
                FirstClassId: $scope.status.isDataOfFirst ? $stateParams.nodeid : '',
            };
            if ($scope.status.listMode === 'banmian') {
                params.start = $scope.data.panels[index].MDATE;
                params.end = $scope.data.panels[index].MDATE;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                data = data.data;
                angular.forEach(data, function(value, key) {
                    value.METADATAID = value.id;
                    value.DOCTYPEID = '1';
                    value.TITLE = value.articleTitle;
                    value.SHARETIME = value.postTime;
                });
                if ($scope.status.listMode === 'banmian') {
                    $scope.data.panels[index].DOCUMENTS = data;
                    if ($scope.data.panels[index].DOCUMENTS.length > 0) {
                        // 显示第一个详情
                        showDetail($scope.data.panels[index].DOCUMENTS[0]);
                    }
                    // cacheCurPageIds(data);
                    // 缓存打开面板后的选项
                    // selectedCurrentsArray(data);
                    initOperFlag($scope.data.panels[index].DOCUMENTS);
                    getDraftRecord($scope.data.panels[index].DOCUMENTS);
                    getGroupIssuedCounts($scope.data.panels[index].DOCUMENTS);
                    // 储存翻页信息
                    storageListenerService.previewPageTurningStorage($scope.data.panels[index].DOCUMENTS, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                } else {
                    $scope.data.items = data;
                    if ($scope.data.items.length > 0) {
                        // 显示第一个详情
                        showDetail($scope.data.items[0]);
                    }
                    // cacheCurPageIds(data);
                    // 缓存打开面板后的选项
                    initOperFlag($scope.data.items);
                    getDraftRecord($scope.data.items);
                    getGroupIssuedCounts($scope.data.items);
                    // 储存翻页信息
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                }

                localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
            });
        }

        /**
         * [queryItemsByPanel description]
         *
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        function queryItemsByPanel(index) {
            if ($scope.status.isUGC) {
                queryUGCItemsByPanel(index);
            } else {
                var params = angular.copy($scope.params);
                params.methodname = $scope.status.isDataOfFirst ? 'queryShareDocsForCloudOfFirst' : 'queryShareDocsForCloud';
                params.ShareTimeStart = $scope.data.fromdate;
                params.ShareTimeEnd = $scope.data.untildate;
                params.PageSize = 20;
                params.CurrPage = $scope.page.CURRPAGE;
                if ($scope.status.listMode === 'banmian') {
                    params.ShareTimeStart = $scope.data.panels[index].MDATE + ' 00:00:00';
                    params.ShareTimeEnd = $scope.data.panels[index].MDATE + ' 23:59:59';
                    params.CurrPage = $scope.data.panels[index].currPage;
                }
                $scope.loadingPromise = trsHttpService
                    .httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        if ($scope.status.listMode === 'banmian') {
                            $scope.data.panels[index].DOCUMENTS = $scope.data.panels[index].DOCUMENTS
                                ? $scope.data.panels[index].DOCUMENTS.concat(data.DATA)
                                : data.DATA;
                            $scope.data.panels[index].pageCount = data.PAGER.PAGECOUNT;
                            for (var i = 0; i < $scope.data.panels[index].DOCUMENTS.length; i++) {
                                $scope.data.panels[index].DOCUMENTS[i].FGDAUTHOR = trsspliceString.spliceString(
                                    $scope.data.panels[index].DOCUMENTS[i].FGD_AUTHINFO,
                                    'USERNAME',
                                    ' '
                                );
                            }
                            return initOperFlag($scope.data.panels[index].DOCUMENTS);
                        } else {
                            $scope.data.items = data.DATA;
                            $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                            $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                            for (var i = 0; i < $scope.data.items.length; i++) {
                                $scope.data.items[i].FGDAUTHOR = trsspliceString.spliceString($scope.data.items[i].FGD_AUTHINFO, 'USERNAME', ' ');
                            }
                            return initOperFlag($scope.data.items);
                        }
                    })
                    .then(function() {
                        if ($scope.status.listMode === 'banmian') {
                            getDraftRecord($scope.data.panels[index].DOCUMENTS);
                            requestListImg($scope.data.panels[index].DOCUMENTS);
                            getGroupIssuedCounts($scope.data.panels[index].DOCUMENTS);
                            if ($scope.data.panels[index].DOCUMENTS.length > 0) {
                                // 显示第一个详情
                                showDetail($scope.data.panels[index].DOCUMENTS[0]);
                            }
                            // 储存翻页信息
                            storageListenerService.previewPageTurningStorage(
                                $scope.data.panels[index].DOCUMENTS,
                                'METADATAID,DOCTYPEID',
                                'fusiongxgPreview'
                            );
                        } else {
                            getDraftRecord($scope.data.items);
                            requestListImg($scope.data.items);
                            getGroupIssuedCounts($scope.data.items);
                            if ($scope.data.items.length > 0) {
                                // 显示第一个详情
                                showDetail($scope.data.items[0]);
                            }
                            // 储存翻页信息
                            storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,DOCTYPEID', 'fusiongxgPreview');
                        }
                        localStorageService.set('fusiongxgPreviewNode', $scope.basicParams.nodeId);
                    });
                getFilterDataBack();
            }
        }

        /**
         * [requestListImg description] 查询列表图示
         * @param  {[type]} items [description] 当前面板或ES列表数据
         * @return {[type]}       [description]
         */
        function requestListImg(items) {
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: 'queryAllImgLogo',
                metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                angular.forEach(items, function(value, key) {
                    value.ALLIMG = data[value.METADATAID];
                });
            });
        }

        /**
         * [initOperFlag description] 获取取签见撤重信息
         * @param  {[type]} documents [description] 当前面板或ES列表数据
         * @return {[type]}           [description]
         */
        function initOperFlag(documents) {
            var deferred = $q.defer();
            var docIds = trsspliceString.spliceString(documents, 'METADATAID', ',');
            if (docIds) {
                if ($scope.status.isUGC === true) {
                    params = {
                        serviceid: 'mlf_ugc',
                        methodname: 'queryFlag',
                        UgcIds: docIds,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        var temp = data;
                        for (var i in temp) {
                            if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                                data[i].METADATAID = data[i].UGCID;
                                $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                            }
                        }
                        deferred.resolve();
                    });
                } else {
                    var params = angular.extend($scope.basicParams, {
                        MetaDataIds: docIds,
                    });
                    resourceCenterService.getWcmTags(params).then(function(data) {
                        var temp = data;
                        for (var i in temp) {
                            if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                                $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                            }
                        }
                        deferred.resolve();
                    });
                }
            } else {
                deferred.reject();
            }
            return deferred.promise;
        }

        /**
         * [getDraftRecord description] 获得取稿件人
         * @param  {[type]} items [description] 当前面板或ES列表数据
         * @return {[type]}       [description]
         */
        function getDraftRecord(items) {
            var params = {
                serviceid: 'mlf_releasesource',
                methodname: 'queryQuOpers',
                MetaDataIds: trsspliceString.spliceString(items, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(data) {
                for (var i = 0; i < items.length; i++) {
                    var operUsers = data[items[i].METADATAID];
                    operUsers = $filter('unique')(operUsers, 'OPERUSER');
                    items[i].OPERUSER = trsspliceString.spliceString(operUsers, 'OPERUSER', ' ');
                }
            });
        }

        /**
         * [getGroupIssuedCounts description] 获取集团已发数
         * @param  {[type]} items [description] 当前所有稿件
         * @return {[type]}       [description]
         */
        function getGroupIssuedCounts(items) {
            var params = {
                serviceid: 'mlf_releaseSource',
                methodname: 'queryGroupIssuedCounts',
                MetaDataIds: trsspliceString.spliceString(items, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                angular.forEach(items, function(value, key) {
                    value.ISSUEDCOUNTS = data[value.METADATAID];
                });
            });
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description] 稿件id
         * @param  {[type]} flagIndex [description] 取签见撤重序号
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description] 稿件id
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].METADATAID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} ChnlDocId  [description] 取签见撤重 点击弹出
         * @param  {[type]} showRepeat [description]
         * @param  {[type]} showClick [description]
         * @param  {[type]} $event [description]
         * @return {[type]}            [description]
         */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick, $event) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var infoModal = resCtrModalService.infoModal(ChnlDocId, showRepeat, showClick, operFlags, $scope.status.isUGC);
            event.stopPropagation();
        };

        /**
         * [pageChanged description] 分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData(true);
        };

        /**
         * [panelLoadMore description] 当前面板加载更多
         * @param  {[type]} index    [description] 当前面板的index
         * @param  {[type]} currPage [description] 当前面板的页码
         * @return {[type]}          [description]
         */
        $scope.panelLoadMore = function(index) {
            $scope.data.panels[index].currPage++;
            queryItemsByPanel(index);
        };

        /**
         * [loadMore description] 图集-加载更多图片
         * @return {[type]} [description]
         */
        $scope.loadMore = function() {
            $scope.page.CURRPAGE++;
            requestData();
        };

        /**
         * [showSelectedArea description] 数据地域信息的级联菜单获取数据
         * @param  {[type]} node [description] 当前节点
         * @return {[type]}      [description]
         */
        $scope.showSelectedArea = function(node) {
            var deffer = $q.defer();
            resourceCenterService.getArea(node).then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };

        /**
         * [searchWithArea description] 根据地域信息筛选稿件
         * @return {[type]} [description]
         */
        $scope.searchWithArea = function() {
            if ($scope.data.casDataArea.length === 0) {
                return;
            }
            $scope.data.areaId = $scope.data.casDataArea[0][$scope.data.casDataArea.length - 1].id;
            if ($scope.data.areaId != '-1') {
                $scope.status.isESSearch = true;
                $scope.page.CURRPAGE = '1';
                requestData();
            }
        };

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下回车也能提交]
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if ($scope.status.isUGC) {
                    $scope.status.UGCSearch = true;
                    $scope.page.CURRPAGE = '1';
                    UGCSearch();
                } else {
                    $scope.status.isESSearch = true;
                    $scope.page.CURRPAGE = '1';
                    requestData();
                }
            }
        };

        /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
        $scope.singleGraphMode = function() {
            $scope.page.CURRPAGE = 1;
            $scope.data.items = [];
            $scope.status.singleGraph = !$scope.status.singleGraph;
            requestData();
        };
        // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /**
         * [showSearch description] 显示隐藏搜索框
         * @return {[type]} [description]
         */
        $scope.showSearch = function() {
            $scope.status.searchShow = !$scope.status.searchShow;
        };

        /**
         * [showScreen description] 显示隐藏搜索框
         * @return {[type]} [description]
         */
        $scope.showScreen = function() {
            $scope.status.screenShow = !$scope.status.screenShow;
        };

        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.showDetail = function(item) {
            showDetail(item);
        };

        /**
         * [showDetail description] 展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        function showDetail(item) {
            $scope.status.showRightDetail = false;
            $scope.data.rebuildData = {
                metaDataId: item.METADATAID,
                type: item.DOCTYPEID, // 类型：图集或者文字稿
                shareUser: item.SHAREUSRTRUENAME || item.FGDAUTHOR, // 共享人
            };
            $timeout(function() {
                $scope.status.curSelected = item.METADATAID;
                $scope.status.showRightDetail = true;
                $state.params.metadata = item.METADATAID;
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
            });
        }

        /**
         * [plainView description] 普通视图
         * @return {[type]} [description]
         */
        $scope.plainView = function() {
            $state.go('front.resourcectrl.share.resource', $stateParams);
        };

        /**
         * [switchList 切换列表模式与版面模式]
         *
         * @param   {[type]}  mode  [mode description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.switchList = function(mode) {
            $scope.status.listMode = mode;
            resSharedService.setListMode(mode), requestData();
        };
    },
]);
